import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5385ab8e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=5385ab8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385ab8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5385ab8e')) {
      api.createRecord('5385ab8e', component.options)
    } else {
      api.reload('5385ab8e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5385ab8e&scoped=true&", function () {
      api.rerender('5385ab8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/Index.vue"
export default component.exports